import { render, staticRenderFns } from "./HistoryOrders.vue?vue&type=template&id=310f3df6&scoped=true&"
import script from "./HistoryOrders.vue?vue&type=script&lang=js&"
export * from "./HistoryOrders.vue?vue&type=script&lang=js&"
import style0 from "./HistoryOrders.vue?vue&type=style&index=0&id=310f3df6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310f3df6",
  null
  
)

export default component.exports